<script lang="ts">
    import Icon from '@iconify/svelte'
    import { route, type RouteResult } from '@mateothegreat/svelte5-router'

    import { resolve } from 'hydria/services/gettext'
    import { spath } from 'hydria/svelte_helpers'

    import { currentRoutePost, currentRouteTag } from 'admin/routes'

    let { item } = $props()

    let badge = $derived(item.badge != null ? item.badge : null)

    let isActive = $derived((item.activeTag != null && $currentRouteTag == item.activeTag) || $currentRouteTag == item.link || (item.active != null && $currentRoutePost?.result?.path?.original?.match(item.active)))
</script>

<div class="nav-item">
    <a href={spath(item.link)} use:route class:active={isActive}>
        <span class="icon"><Icon inline icon={item.icon} /></span>
        <span class="title">
            <span class="text">{$resolve(item.name)}</span>
            {#if item.badge != null && $badge != null}
                <span class="extra"><span class="badge">{$badge}</span></span>
            {/if}
        </span>
    </a>
</div>
